import React, { Fragment, useState } from "react";

import { ExpandLess, ExpandMore } from "@material-ui/icons";

import Collapse from "@material-ui/core/Collapse";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { makeStyles } from "@material-ui/core/styles";

import { Link } from "react-router-dom";
import { withRouter } from "react-router";

const useStyles = makeStyles(theme => ({
  icon: {
    minWidth: "35px"
  },
  nested: {
    paddingLeft: theme.spacing(6)
  }
}));

function Submenu(props) {
  const classes = useStyles();
  const {
    children,
    items,
    menuPrefix = [],
    location: { pathname }
  } = props;

  const [open, setOpen] = useState(menuPrefix.includes(pathname.split("/")[1]));

  function openSubmenu() {
    setOpen(!open);
  }
  return (
    <Fragment>
      <MenuItem button onClick={openSubmenu}>
        {children}
        {open ? <ExpandLess /> : <ExpandMore />}
      </MenuItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <MenuList component="div" disablePadding>
          {items.map(({ id, name, to, hasAccess }) => {
            if (!hasAccess) return null;
            return (
              <MenuItem
                key={id}
                className={classes.nested}
                component={Link}
                to={to}
                selected={to.split("?")[0] === pathname}
              >
                <ListItemText
                  primary={name}
                // primaryTypographyProps={{ variant: "overline" }}
                />
              </MenuItem>
            );
          })}
        </MenuList>
      </Collapse>
    </Fragment>
  );
}

export default withRouter(Submenu);
